import type { ProjectConfigInput } from '#schema/ProjectConfigSchema';

export const config = {
  id: 'cognite-dashboard-core',
  name: 'Cognite Dashboard',
} as const satisfies ProjectConfigInput;
